module.exports = __webpack_public_path__ + "static/img/h5-video-mark.01f19b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/h5-video-mark.png
// module id = 4CYC
// module chunks = 0